var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgPinterest = function SvgPinterest(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.177,
    height: 18.222,
    viewBox: "0 0 14.177 18.222",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 38425",
    d: "M8.272 13.217a4.961 4.961 0 0 1-2.445-1.164c-.478 2.508-1.062 4.913-2.793 6.169-.535-3.792.784-6.639 1.4-9.662-1.044-1.758.126-5.3 2.328-4.424 2.71 1.072-2.346 6.536 1.048 7.218 3.544.712 4.991-6.15 2.793-8.382C7.424-.251 1.356 2.9 2.1 7.512c.182 1.128 1.347 1.47.466 3.026C.535 10.089-.071 8.485.007 6.349A6.84 6.84 0 0 1 6.177.062C10-.367 13.6 1.467 14.093 5.067c.558 4.064-1.728 8.465-5.821 8.149",
    fill: "#221f1f"
  })));
};
export default SvgPinterest;